
export enum EntityChangeRequestTypeEnum {
    contact = 'CONTACT',
    outlet = 'OUTLET'
}

export interface EntityChangeRequestApiModel {
    entityType: EntityChangeRequestTypeEnum | null;
    entityName: string;
    entityId: string;
    note: string;
}
